// Type //
type Filter = {
    filterVal: String,
    comparator: String,
}

export type FilterType = {
    type: Filter
};

// Important //
export const DocumentFormContainerClass = 'document-detail-form-container'

export const FieldStatus = {
    Valid: 'is-valid',
    Invalid: 'is-invalid'
}

// Mode //
export const ActionMode = {
    View: 'View',
    Edit: 'Edit',
    History: 'History'
}

export const DeletionMode = {
    Restore: 'Restore',
    Remove: 'Remove',
    Delete: 'Delete'
}

export const HistoryMode = {
    NoCompare: 'NoCompare',
    CompareWithPrevious: 'CompareWithPrevious',
    CompareWithCurrent: 'CompareWithCurrent'
}

// Name //
export const Template = {
    Invoice: 'Invoice',
    SupplierContract: 'Supplier Contract',
    Others: 'Others',
    DependentDocuments: 'Dependent Documents',
    EmployeeDocument: 'Employee Document'
}

export const TemplateOrder = {
    'Supplier Contract': 1,
    'Invoice': 2,
    'Employee Document': 3,
    'Dependent Documents': 4,
    'Others': 5
} 

export const FieldDataType = {
    String: 'String',
    Decimal: 'Decimal',
    Integer: 'Int',
    Date: 'Date'
}

export const DocumentStatus = {
    Complete: 'Complete',
    Incomplete: 'Incomplete'
}

export const Permission = {
    Document: {
        FullControl: 'Document.FullControl',
        ReadOnly: 'Document.ReadOnly'
    }
}

// Config //
export const Comparator = {
    Equal: '=',
    IsIn: 'IN'
}

export const ContractNumber = {
    InputMask: 'CON999999999',
    Regex: /^(CON)\d{9}$/
}

export const ShippingDocument = {
    InputMask: 'OTH999999999',
    Regex: /^(OTH)\d{9}$/
}

export const Separator = ', '
export const Connector = ' - '
export const Empty = ''
export const Percent = '%'
export const RequiredMask = '*'
export const SelectorPlaceholder = 'Select...'